// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

// Filter controls marked data-auto-submit submit their form as soon as they change. One delegated
// listener instead of inline onchange attributes, which the Content Security Policy blocks (see
// config/initializers/content_security_policy.rb). event.target.form also resolves a control that
// points at its form with a form="..." attribute from outside it.
document.addEventListener("change", (event) => {
  if (event.target.matches?.("[data-auto-submit]")) event.target.form?.requestSubmit()
})
